/**
 * Use this file for JavaScript code that you want to run in the front-end 
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any 
 * JavaScript running in the front-end, then you should delete this file and remove 
 * the `viewScript` property from `block.json`. 
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */

const filter_obj = {};

document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".filter_group").forEach((group) => {
    filter_obj[group.dataset.filter_name] = [];
  });

  restoreFilterStateFromQuery();

  const toggle_box_arr = document.querySelectorAll(".toggle_box");
  for (const toggle_box of toggle_box_arr) {
    const toggle = toggle_box.querySelector(".toggle_box__switch");

    toggle.addEventListener("click", (event) => {
      toggle_box.classList.toggle("toggle_box--open");
    });

    document.addEventListener("click", (event) => {
      if (!toggle_box.contains(event.target)) {
        toggle_box.classList.remove("toggle_box--open");
      }
    });

    // Add event listeners for filter options
    toggle_box.querySelectorAll(".filter_group").forEach((group) => {
      group.querySelectorAll(".filter-size").forEach((filter) => {
        filter.addEventListener("click", () => {
          const key = group.dataset.filter_name;
          const value = filter.dataset.filter_value;

          filter.classList.toggle("selected");
          filter.classList.contains("selected")
            ? filter_obj[key].push(value)
            : (filter_obj[key] = filter_obj[key].filter((v) => v !== value));

          updateCount();
        });
      });
    });

    // Add event listeners for sorting options
    toggle_box.querySelectorAll(".sort_text[data-order]").forEach((sort_option) => {
      sort_option.addEventListener("click", () => {
        const sort_order = sort_option.dataset.order;
        updateQueryWithSort(sort_order);
      });
    });
  }

  document.querySelector(".check-btn")?.addEventListener("click", () => {
    updateQuery();
  });

  document.querySelector(".delete-btn")?.addEventListener("click", () => {
    document.querySelectorAll(".filter-size.selected").forEach((filter) => {
      filter.classList.remove("selected");
    });
    Object.keys(filter_obj).forEach((key) => (filter_obj[key] = []));
    updateCount();
    updateQuery();
  });

  updateCount();
});

function restoreFilterStateFromQuery() {
  const query_params = new URLSearchParams(window.location.search);

  Object.keys(filter_obj).forEach((key) => {
    const values = query_params.get(key)?.split("-") || [];
    filter_obj[key] = values;

    values.forEach((value) => {
      document
        .querySelectorAll(
          `.filter_group[data-filter_name="${key}"] .filter-size`
        )
        .forEach((filter) => {
          if (value === filter.dataset.filter_value) {
            filter.classList.add("selected");
          }
        });
    });
  });
}

function updateQuery() {
  const query_params = new URLSearchParams(window.location.search);
  Object.entries(filter_obj).forEach(([key, values]) => {
    if (values.length) {
      query_params.set(key, values.join("-"));
    }
    else if (query_params.get(key)) {
      query_params.delete(key);
    }

  });

  let new_location = location.pathname;
  if ([...query_params].length) {
    new_location += "?" + query_params;
  }
  history.replaceState({}, "", new_location);
  location.reload();
}

function updateQueryWithSort(sort_order) {
  const query_params = new URLSearchParams(window.location.search);
  const order_parts = sort_order.split('-');

  if (sort_order === '') {
    query_params.delete("orderby");
    query_params.delete("order");
  }
  else {
    if (order_parts[0]) {
      query_params.set("orderby", order_parts[0]);
    }
    if (order_parts[1]) {
      query_params.set("order", order_parts[1]);
    }
  }

  let new_location = location.pathname;
  if ([...query_params].length) {
    new_location += "?" + query_params;
  }
  history.replaceState({}, "", new_location);
  location.reload();
}

document.addEventListener("DOMContentLoaded", () => {
  const query_params = new URLSearchParams(window.location.search);
  const sort_display = document.querySelector(".sort_count");
  const selected_order = [];
  const orderby = query_params.get("orderby");
  const order = query_params.get("order");
  if (orderby)
    selected_order.push(orderby);
  if (order)
    selected_order.push(order);

  document.querySelectorAll(".sort_text").forEach((element) => {
    element.style.fontWeight = element.dataset.order === selected_order.join("-") ? "bold" : "normal";
  });

  if (orderby === "price") {
    sort_display.textContent = "Cena";
  }
});

function updateCount() {
  let total = 0;
  document.querySelectorAll(".filter_group").forEach((group) => {
    const key = group.dataset.filter_name;
    const count = filter_obj[key].length;
    group.querySelector(".filter_count").textContent = count;
    total += count;
  });
  const count_el = document.querySelector(".count");
  if (count_el) {
    count_el.textContent = total;
  }
}

document.addEventListener("DOMContentLoaded", function () {
  const back_button = document.querySelector(".back_div__button");
  const site_url = back_button.dataset.site_url;

  back_button.addEventListener("click", function (event) {
    event.preventDefault();

    const referrer = document.referrer;

    if (!referrer || !referrer.includes(window.location.origin) || history.length <= 1) {
      window.location.href = site_url;
    } else {
      history.back();
    }
  });
});
